module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAaklEQVRIx2NgqIrDg84JquFBfy6K4UEMo0aPGk0toy8rqwARTYx+kif3JFeeykZf0VH5uETq93mx3+fEgAwgl5quvqym8ueCGBABGVQOkAdxCk/z5Z7mywMZVDb6vKgqGmM0XY8aPXiNBgDB6fXllaZS5AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/cm.png
// module id = 797
// module chunks = 0